import React from 'react'

const HistoryH = () => {
  return (
    <div>
      HistoryH
    </div>
  )
}

export default HistoryH
